import { Component, Input } from '@angular/core';
import { CommonService } from '../../service/common.service';

@Component({
    selector: 'app-audio-video-permission',
    templateUrl: './audio-video-permission.component.html',
    standalone: false
})
export class AudioVideoPermissionComponent {
 @Input() showAudioModal = false;
  @Input() showVideoModal = false;
  @Input() videoCountdown: number = 0;

  constructor( public commonService: CommonService,) { }
}
